<template>
  <div class="misc-wrapper">

    <div class="misc-inner">
      <div class="w-100 text-center">
        <h2 class="mb-1">
         {{ is_espejo ? $t('error.soldoutViewsEspejo') : $t('error.soldoutViews') }}
        </h2>
        <p class="mb-2 avenir-medium">
          {{ is_espejo ? $t('error.noticeViewsEspejo') : $t('error.noticeViews') }}
        </p>

        <p class="mb-2 avenir-medium" v-if="is_espejo">
          {{ $t('error.noticeViewsEspejo2') }}
        </p>

        <b-button
          variant="primary"
          class="mb-2 btn-sm-block"
          @click="redirectPackage()"
          v-if="!is_espejo"
        >
          {{$t('error.buyPackage')}}
        </b-button>
        <b-button
          variant="primary"
          class="mb-2 btn-sm-block"
          @click="redirectCampaigns()"
          v-else
        >
          {{$t('error.buyPackageEspejo')}}
        </b-button>
      </div>
      <div class="w-100 text-center">
        <!-- image -->
        <b-img
          fluid
          :src="downImg"
          alt="Error page"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { getUserData } from '@/auth/utils';
import { BButton, BImg } from 'bootstrap-vue'
export default {
  components: {
    BButton,
    BImg,
  },
  data () {
    return {
      downImg: require('@/assets/images/pages/error.svg'),
      is_espejo: getUserData()?.main_group?.name === 'espejo',
    }
  },
  methods: {
    redirectPackage () {
      this.$router.push({ name: 'pages-account-setting', params: { section: 'membership', tab: 'packages' } }).catch(() => {})
    },
    redirectCampaigns () {
      this.$router.push({ name: 'campaigns' }).catch(() => {})
    },
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
